<template>
  <div class="content">
    <h1 class="is-hidden">Formelsammlung</h1>
    <div class="box">
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped has-text-centered">
          <tbody>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'formulas-dc'}" class="inherited">
                  <div class="p-2">
                    Gleichstrom
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td>Elektrisches Feld & Kondensator <i>(in Arbeit)</i></td>
            </tr>
            <tr class="is-clickable">
              <td>Magnetisches Feld <i>(in Arbeit)</i></td>
            </tr>
            <tr class="is-clickable">
              <td>Wechselstrom <i>(in Arbeit)</i></td>
            </tr>
            <tr class="is-clickable">
              <td>Drehstrom <i>(in Arbeit)</i></td>
            </tr>
            <tr class="is-clickable">
              <td>Transformator <i>(in Arbeit)</i></td>
            </tr>
            <tr class="is-clickable">
              <td>Sonstiges <i>(in Arbeit)</i></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ee-formulas',
  metaInfo: {
    title: 'Elektrotechnik Formelsammlung | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Sammlung verschiedener Formeln aus der Elektrotechnik.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Formelsammlung', route: 'start' })
  }
}
</script>
